document.addEventListener('DOMContentLoaded', () => {

const addToCartBtn = document.querySelector('[data-add-to-cart].sticky-product-form__cart-submit');
const productForm = addToCartBtn?.closest('form');
const sizeSelect = document.querySelector('select[name="options[Size]"]');
const sizeWrapper = sizeSelect?.closest('.product__option');
const chips = sizeWrapper?.querySelectorAll('.product__chip');
const sourceSpan = document.querySelector('[data-selected-value-for-option][data-option-name="option1"]');
const targetSpan = document.querySelector('.cart-bar__variant');

if (!sourceSpan || !targetSpan) return;

function updateVariant(){
    targetSpan.textContent = sourceSpan.textContent.trim();
}

updateVariant();

const observer = new MutationObserver(updateVariant);

observer.observe(sourceSpan,{
    childList:true,
    characterData:true,
    subtree:true
});

if (!productForm || !sizeSelect || !sizeWrapper) return;

setTimeout(() => {

    sizeSelect.selectedIndex = -1;

    chips?.forEach(chip => chip.classList.remove('selected'));

}, 50);

function showInlineError(){

    if(sizeWrapper.querySelector('.size-error-message')) return;

    const error = document.createElement('div');
    error.className = 'size-error-message';
    error.textContent = 'Select a Size';

    sizeWrapper.appendChild(error);
}

function clearInlineError(){

    const error = sizeWrapper.querySelector('.size-error-message');

    if(error) error.remove();

}

function shakeButton(){

    addToCartBtn.classList.add('btn-shake');

    setTimeout(()=>{
    addToCartBtn.classList.remove('btn-shake');
    },600);

}

function scrollToSize(){

    sizeWrapper.scrollIntoView({
    behavior:'smooth',
    block:'center'
    });

}

productForm.addEventListener('submit',(e)=>{

    if(!sizeSelect.value){

    e.preventDefault();

    showInlineError();
    shakeButton();
    scrollToSize();

    }

});

sizeSelect.addEventListener('change', clearInlineError);

chips?.forEach(chip => {
    chip.addEventListener('click', clearInlineError);
});

});